import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

const QUERY_KEY = ["/api/my/following"];

export function useFollowing() {
  const queryClient = useQueryClient();

  const { data } = useQuery<{ id: string; producerId: string }[]>({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const res = await fetch("/api/my/following", { credentials: "include" });
      if (res.status === 401) return [];
      if (!res.ok) throw new Error(await res.text());
      return res.json();
    },
    staleTime: 30_000,
  });

  const followingSet = new Set((data ?? []).map((p: any) => p.id));

  const toggleFollow = useCallback(
    async (producerId: string) => {
      const wasFollowing = followingSet.has(producerId);

      try {
        await fetch(`/api/producers/${producerId}/follow`, {
          method: wasFollowing ? "DELETE" : "POST",
          credentials: "include",
        });
        queryClient.invalidateQueries({ queryKey: QUERY_KEY });
        queryClient.invalidateQueries({ queryKey: ["/api/my/following-feed"] });
      } catch {
        queryClient.invalidateQueries({ queryKey: QUERY_KEY });
      }
    },
    [followingSet, queryClient],
  );

  return { followingSet, toggleFollow };
}
